import { render, staticRenderFns } from "./EndorsementInvite.vue?vue&type=template&id=dc33b1e8&scoped=true&"
import script from "./EndorsementInvite.vue?vue&type=script&lang=js&"
export * from "./EndorsementInvite.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementInvite.vue?vue&type=style&index=0&id=dc33b1e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc33b1e8",
  null
  
)

export default component.exports